import { GetCaseReportsQuery } from "./caseReports.types";

const caseReportsQueryKeys = {
  base: ["case-reports"] as const,
  all: ["case-reports", "list"] as const,
  list: (q: GetCaseReportsQuery) => ["case-reports", "list", q] as const,
  infiniteList: (q: GetCaseReportsQuery) =>
    ["case-reports", "infinite-list", q] as const,
};

export const CaseReportsQuery = {
  queryKeys: caseReportsQueryKeys,
};
